module.exports = __webpack_public_path__ + "img/img-8.03939a2a.png";